/* eslint-disable react/no-multi-comp */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment, Component } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { TettraEditor } from './TettraEditor';
import { isAnchorOrHasAnchorParent } from '../utilities/domUtilities';
import { withEditorState } from './EditorStateContext';

class TableColumnHandle extends Component {
    state = {
        isOpen: false,
    };

    onUpdate = (method) => {
        const { columnNumber } = this.props;
        method(columnNumber);
        this.setState({ isOpen: false });
    };

    render() {
        const {
            columnNumber,
            rowNumber,
            activeColumn,
            insertColumnBefore,
            insertColumnAfter,
            config,
            deleteColumn,
            onHoverCell,
        } = this.props;

        const { isOpen } = this.state;

        let isActive = isOpen || columnNumber === activeColumn;

        if (config.readOnly) {
            isActive = false;
        }

        const content = (
            <Fragment>
                <div
                    className="table-column-handle-wrapper"
                    onMouseOver={() => onHoverCell(rowNumber, columnNumber)}
                    onFocus={() => onHoverCell(rowNumber, columnNumber)}
                >
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            this.setState({ isOpen: !isOpen });
                        }}
                    >
                        <img className="button-icon" height="18" width="4" src="/img/icons/dropdown-elipsis.svg" alt="" />
                    </button>
                </div>
                <ul
                    className={`table-context-menu${isOpen ? '' : ' hidden'}`}
                >
                    <li
                        className="table-context-menu-item"
                        onMouseDown={() => this.onUpdate(insertColumnBefore)}
                    >
                        Insert Column Before
                    </li>
                    <li
                        className="table-context-menu-item"
                        onMouseDown={() => this.onUpdate(insertColumnAfter)}
                    >
                        Insert Column After
                    </li>
                    <li
                        className="table-context-menu-item"
                        onMouseDown={() => this.onUpdate(deleteColumn)}
                    >
                        Delete Column
                    </li>
                </ul>
            </Fragment>
        );

        return (
            <td
                className={`table-column-handle ${isActive ? 'active' : ''} ${isOpen ? 'open' : ''}`}
                key={`column-${columnNumber}-handle`}
            >
                {isOpen ? (
                    <OutsideClickHandler
                        disabled={isActive !== true}
                        onOutsideClick={() => this.setState({ isOpen: false })}
                    >
                        {content}
                    </OutsideClickHandler>
                )
                    : content}
            </td>
        );
    }
}

class TableRowHandle extends Component {
    state = {
        isOpen: false,
    };

    onUpdate = (method) => {
        const { rowNumber } = this.props;
        method(rowNumber);
        this.setState({ isOpen: false });
    };

    render() {
        const {
            rowNumber,
            columnNumber,
            activeRow,
            insertRowBefore,
            insertRowAfter,
            config,
            deleteRow,
            onHoverCell,
        } = this.props;

        const { isOpen } = this.state;

        let isActive = isOpen || rowNumber === activeRow;

        if (config.readOnly) {
            isActive = false;
        }

        const content = (
            <Fragment>
                <div
                    className="table-row-handle-wrapper"
                    onMouseOver={() => onHoverCell(rowNumber, columnNumber)}
                    onFocus={() => onHoverCell(rowNumber, columnNumber)}
                >
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            this.setState({ isOpen: !isOpen });
                        }}
                    >
                        <img className="button-icon" height="18" width="4" src="/img/icons/dropdown-elipsis.svg" alt="" />
                    </button>
                </div>
                <ul
                    className={`table-context-menu${isOpen ? '' : ' hidden'}`}
                >
                    <li
                        className="table-context-menu-item"
                        onMouseDown={() => this.onUpdate(insertRowBefore)}
                    >
                        Insert Row Before
                    </li>
                    <li
                        className="table-context-menu-item"
                        onMouseDown={() => this.onUpdate(insertRowAfter)}
                    >
                        Insert Row After
                    </li>
                    <li
                        className="table-context-menu-item"
                        onMouseDown={() => this.onUpdate(deleteRow)}
                    >
                        Delete Row
                    </li>
                </ul>
            </Fragment>
        );

        return (
            <td
                className={`table-row-handle ${isActive ? 'active' : ''} ${isOpen ? 'open' : ''}`}
                key={`row-${rowNumber}-handle`}
            >
                {isOpen === true ? (
                    <OutsideClickHandler onOutsideClick={() => this.setState({ isOpen: false })}>
                        {content}
                    </OutsideClickHandler>
                )
                    : content}
            </td>
        );
    }
}

class TableCell extends Component {
    updateEditorState = (editorState) => {
        const { updateTable, rowNumber, columnNumber } = this.props;

        updateTable(
            rowNumber,
            columnNumber,
            editorState,
        );
    };

    render() {
        const {
            activeEditor,
            onHoverCell,
            tableKey,
            rowNumber,
            columnNumber,
        } = this.props;

        const locationKey = `${tableKey}-${rowNumber}-${columnNumber}`;

        return (
            <td
                className="table-cell"
                onMouseOver={() => onHoverCell(rowNumber, columnNumber)}
                onFocus={() => onHoverCell(rowNumber, columnNumber)}
            >
                <TettraEditor
                    ref={(element) => { this.editor = element; }}
                    isNestedEditor
                    {...this.props}
                    readOnly={locationKey !== activeEditor}
                    locationKey={locationKey}
                    className="editor-in-cell"
                    onChange={this.updateEditorState}
                />
            </td>
        );
    }
}

const Row = ({ cells, ...props }) => (
    <tr className="table-row">
        <TableRowHandle {...props} />
        {cells.map((editorState, idx) => (
            <TableCell
                {...props}
                columnNumber={idx}
                key={idx}
                editorState={editorState}
            />
        ))}
    </tr>
);

class Table extends Component {
    state = {
        activeRow: 0,
        activeColumn: 0,
    };

    onHoverCell = (activeRow, activeColumn) => {
        const { config } = this.props;

        if (config.readOnly !== true) {
            this.setState({ activeRow, activeColumn });
        }
    };

    render() {
        const { rows, ...props } = this.props;
        return (
            <div className="table-container">
                <table data-table-id={props.tableKey} className="tettra-table">
                    <tbody>
                        <tr>
                            <td className="table-top-left-corner" key="top-left-corner" />
                            {(rows[0] || []).map((_, index) => (
                                <TableColumnHandle
                                    key={`column-handle-${index}`}
                                    {...props}
                                    {...this.state}
                                    columnNumber={index}
                                    onHoverCell={this.onHoverCell}
                                />
                            ))}
                        </tr>
                        {rows.map((cells, idx) => (
                            <Row
                                {...props}
                                {...this.state}
                                onHoverCell={this.onHoverCell}
                                rowNumber={idx}
                                cells={cells}
                                key={idx}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withEditorState(Table);
